module.exports = __webpack_public_path__ + "static/media/incorrect-face-match.68cb2a5a.gif";